export default "__VITE_ASSET__CCilpNjL__"